import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ButtonStandard, ButtonStandardType } from 'record-it-components/button/ButtonStandard/ButtonStandard';
import { CardListItem, CardListItemSize } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useRequiredWorkTimeEntryToCreate } from '../../../hooks/createWorkTimeEntry/useRequiredWorkTimeEntryToCreate';
import { useTimeTrackingActivityPathName } from '../../../hooks/entity/timeTrackingActivity/useTimeTrackingActivityPathName';
import { useAppDispatch } from '../../../store/hooks';
import { createWorkTimeEntrySlice } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import styles from './WorkTimeEntryToCreateActivityWidget.module.css';
export type WorkTimeEntryToCreateActivityWidgetProps = PropsWithoutChildren<ComponentProps<'div'>>;
export const WorkTimeEntryToCreateActivityWidget: FunctionComponent<WorkTimeEntryToCreateActivityWidgetProps> = React.memo(props => {
  const $ = _c(26);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  if ($[2] !== t0) {
    ({
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
  } else {
    remainingProps = $[3];
  }
  const {
    t
  } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const workTimeEntryToCreate = useRequiredWorkTimeEntryToCreate();
  const selectedActivityPathName = useTimeTrackingActivityPathName(workTimeEntryToCreate.timeTrackingActivityId);
  let t1;
  if ($[4] !== dispatch) {
    t1 = () => {
      dispatch(createWorkTimeEntrySlice.actions.setTimeTrackingActivityId(null));
    };
    $[4] = dispatch;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleRemoveSelectedActivityClick = useEventCallback(t1);
  let t2;
  if ($[6] !== navigate) {
    t2 = () => {
      navigate(RoutePaths.createWorkTimeEntrySelectActivity());
    };
    $[6] = navigate;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleSelectActivityClick = useEventCallback(t2);
  let t3;
  if ($[8] !== t) {
    t3 = t("components.workTime.WorkTimeEntryToCreateActivityWidget.title");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <div className={styles.title}>{t3}</div>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== handleRemoveSelectedActivityClick || $[13] !== selectedActivityPathName) {
    t5 = selectedActivityPathName != null ? <CardListItem size={CardListItemSize.Small} inline={true} data-testid="WorkTimeEntryBreakListItem.SelectedActivity"><CardListItemTitle>{selectedActivityPathName}</CardListItemTitle><CardListItemIconButton {...iconConfigurations.prefixed.listItem.deleteIcon} onClick={handleRemoveSelectedActivityClick} data-testid="WorkTimeEntryBreakListItem.RemoveSelectedActivityButton" /></CardListItem> : null;
    $[12] = handleRemoveSelectedActivityClick;
    $[13] = selectedActivityPathName;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = workTimeEntryToCreate.timeTrackingActivityId ? "activityAlreadySelected" : null;
  let t7;
  if ($[15] !== t || $[16] !== t6) {
    t7 = t("components.workTime.WorkTimeEntryToCreateActivityWidget.selectActivity", {
      context: t6
    });
    $[15] = t;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== handleSelectActivityClick || $[19] !== t7) {
    t8 = <div className={styles.selectActivityButtonWrapper}><ButtonStandard type={ButtonStandardType.Primary} onClick={handleSelectActivityClick} data-testid="WorkTimeEntryBreakListItem.SelectActivityButton">{t7}</ButtonStandard></div>;
    $[18] = handleSelectActivityClick;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== remainingProps || $[22] !== t4 || $[23] !== t5 || $[24] !== t8) {
    t9 = <div {...remainingProps}>{t4}{t5}{t8}</div>;
    $[21] = remainingProps;
    $[22] = t4;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
});